import { BarChart } from '@/components/charts';
import { wrapLabels } from '@/helpers';
import { getBackgroundColorByOppType } from '@/helpers/ChartHelpers/getBackgroundColorByOppType';
import { MatchedGrantsSelectors } from '@/store/matchedGrants';
import { Box, Stack, Typography, useMediaQuery, useTheme } from '@mui/material';
import React, { useRef } from 'react';
import { useSelector } from 'react-redux';
export const GrantMetricsGraph = () => {
    const theme = useTheme();
    const chartRef = useRef();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));
    const typeTotals = useSelector(MatchedGrantsSelectors.makeGrantTotalsByType);
    const createData = () => {
        const entry = { labels: [], datasets: [] };
        const typeEntries = Object.entries(typeTotals);
        typeEntries.forEach(([k, v], idx) => {
            entry.labels.push(k);
            const dataArr = Array(typeEntries.length).fill(0);
            dataArr[idx] = v;
            let backgroundColor = '';
            backgroundColor = getBackgroundColorByOppType(k);
            entry.datasets.push({ label: k, data: dataArr, backgroundColor });
        });
        entry.labels = wrapLabels(entry.labels);
        return entry;
    };
    return (React.createElement(Box, { sx: { flex: '1 1 auto', minHeight: '400px', maxWidth: '100%' } }, createData() && (React.createElement(Stack, null,
        React.createElement(Typography, { variant: "h2", sx: { fontWeight: theme.typography.fontWeightSemiBold, fontSize: '1rem', m: '0.5rem' } }, "Breakdown by opportunity type"),
        React.createElement(BarChart, { data: createData(), ref: chartRef, containerProps: {
                sx: {
                    height: '300px',
                },
            }, options: {
                layout: {
                    padding: isSmallScreen ? 2 : 3,
                },
                indexAxis: isSmallScreen ? 'x' : 'y',
                plugins: {
                    tooltip: {
                        callbacks: {
                            title: function (tooltipItems) {
                                return tooltipItems[0].label.replace(',', ' ');
                            },
                        },
                    },
                },
            } })))));
};
